export default "__VITE_ASSET__D6_H_WaN__"